import React, { useEffect } from 'react';
import { CampdeskLogo } from '@/components/svg/CampdeskLogo.tsx';
import { useNavigate } from '@tanstack/react-router';

const Index = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const redirectTimer = setTimeout(() => {
      navigate({ to: '/auth/login' });
    }, 2000);

    return () => clearTimeout(redirectTimer);
  }, [navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-basic-white">
      <div className="animate-pulse">
        <CampdeskLogo />
      </div>
      <div className="mt-8">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-[#F7CE6E] border-t-transparent"></div>
      </div>
    </div>
  );
};

export default Index;
